import actions from './actions';

const { INDEX_FORM_TABLE_READ_BEGIN, INDEX_FORM_TABLE_READ_SUCCESS, INDEX_FORM_TABLE_READ_ERR } = actions;

const initialState = {
  tableData: [],
  loading: false,
  error: null,
};

const indexFormTableReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case INDEX_FORM_TABLE_READ_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case INDEX_FORM_TABLE_READ_SUCCESS:
      return {
        ...initialState,
        tableData: data,
        loading: false,
      };
    case INDEX_FORM_TABLE_READ_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export default indexFormTableReducer;
